/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1701
 */

require(/* 86 */"./1650/86/index")({
  target: "Reflect",
  stat: true
}, {
  has: function (e, t) {
    return t in e
  }
})
